/**
 * Copyright © 2025-2026 Delicious AI, LLC
 */

import styled from '@emotion/styled'
import { Button as MuiButton, Typography } from '@mui/material'
import { Grid, spacing, SpacingProps } from '@mui/system'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'

import useT from '@/i18n/useT'

interface ButtonProps extends SpacingProps {
  component?: React.ElementType
  to?: string
  target?: string
}

const Button = styled(MuiButton)<ButtonProps>(spacing)

const Wrapper = styled.div`
  text-align: center;
`

function Page404() {
  const { t } = useT()

  return (
    <Wrapper>
      <Helmet title={t('page404.helmet', 'Page Not Found')} />
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        404
      </Typography>
      <Typography component="h2" variant="h4" align="center" gutterBottom>
        {t('page404.title', 'Page not found')}
      </Typography>
      <Typography
        component="h2"
        variant="subtitle1"
        align="center"
        gutterBottom
      >
        {t('page404.subtitle', 'The page you are looking for does not exist.')}
      </Typography>
      <Grid container spacing={2} direction={'column'}>
        <Grid>
          <Button
            component={Link}
            to="/stats"
            variant="contained"
            color="primary"
            fullWidth={false}
            mt={2}
          >
            {t('page404.actions.returnToDashboard', 'Return to dashboard')}
          </Button>
        </Grid>
        <Grid>
          <Button
            component={Link}
            to="/login"
            variant="outlined"
            color="primary"
            fullWidth={false}
            mt={2}
          >
            {t('page404.actions.signIn', 'Sign in')}
          </Button>
        </Grid>
      </Grid>
    </Wrapper>
  )
}

export default Page404
